/**
 * Открывает страницу оплаты в новой вкладке, когда ссылка уже получена.
 * false — браузер заблокировал окно (долгий ответ, iOS); тогда показываем кнопку «Перейти к оплате».
 */
export function openPaymentTab(url) {
  const tab = window.open(url, "_blank");
  if (!tab) return false;
  try {
    tab.opener = null;
  } catch {
    // Окно уже на домене платёжки — ссылку на нашу вкладку снять нельзя, но и не нужно
  }
  return true;
}

/** Переход текущей вкладки на заказ после клика по ссылке оплаты: сначала браузер откроет оплату. */
export function goToOrderAfterClick(orderUrl) {
  if (orderUrl) {
    setTimeout(() => {
      window.location.href = orderUrl;
    }, 300);
  }
}
